function fn_layout_main() {
    $("body").removeClass("mod--preload");
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function(e){
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });

    nl_lib_dialog.init();
    $("[data-switch]").nl_lib_switch();

    $(document).on("click","[data-reg-toggle]",function (e) {
        e.preventDefault();
        var $reg = $(".comp_registration");
        if(!$reg.hasClass("mod--active")){
            $reg.addClass("mod--active");
            $("body").addClass("no-scroll").append("<div class=\"reg_overlay\" data-reg-toggle></div>");
        }
        else {
            $reg.removeClass("mod--active");
            $("body").removeClass("no-scroll");
            $(".reg_overlay").remove();
        }

    });

    // $(document).on("click",function () {
    //     if ($(".comp_registration").hasClass("mod--active")) {
    //         $(".comp_registration").removeClass("mod--active");
    //     };
    // });
}